//[
//     {
//         "ID": 1,
//         "Description": "LEGAL ACCOUNT",
//         "Features": [
//             {
//                 "ID": 1,
//                 "Description": "Overview",
//                 "Slug": "overview",
//                 "IsPage": true,
//                 "Functions": [
//                     "VIEW_LBP_AND_USD_BALANCES",
//                     "VIEW_STATMENT_OF_ACCOUNT_CHARTS"
//                 ]
//             },
//             {
//                 "ID": 2,
//                 "Description": "Pending Approvals",
//                 "Slug": "statementofaccount",
//                 "IsPage": true,
//                 "Functions": [
//                     "APPROVE_AND_REJECT_ALL_TYPES_OF_PENDING_APPROVAL_TRANSACTIONS",
//                     "APPROVE_AND_REJECT_PENDING_EXTERNAL_TRANSFER_TRANSACTIONS",
//                     "APPROVE_AND_REJECT_PENDING_SUYOOL_TO_SUYOOL_TRANSACTIONS",
//                     "APPROVE_AND_REJECT_A_PENDING_PAYROLL",
//                     "APPROVE_AND_REJECT_CASH_WITHDRAWAL_TRANSACTIONS",
//                     "VIEW_PENDING_APPROVAL_TRANSACTIONS",
//                     "APPROVE_PENDING_CARD_REQUESTS"
//                 ]
//             },
//             {
//                 "ID": 3,
//                 "Description": "Statement Of Account",
//                 "Slug": "pendingapprovals",
//                 "IsPage": true,
//                 "Functions": [
//                     "VIEW_TRANSACTIONS_OF_LBP_ACCOUNT",
//                     "VIEW_TRANSACTIONS_DETAILS_OF_LBP_ACCOUNT",
//                     "VIEW_TRANSACTIONS_OF_USD_ACCOUNT",
//                     "VIEW_TRANSACTIONS_DETAILS_OF_USD_ACCOUNT",
//                     "VIEW_DETAILS_OF_CARD_FEES_TRANSACTION",
//                     "VIEW_DETAILS_OF_CLOSE_BALANCE_TRANSACTION"
//                 ]
//             }
//         ]
//     },
//     {
//         "ID": 2,
//         "Description": "TRANSACTIONS",
//         "Features": [
//             {
//                 "ID": 4,
//                 "Description": "External Transfer",
//                 "Slug": "",
//                 "IsPage": true,
//                 "Functions": [
//                     "INITIATE_A_NEW_EXTERNAL_TRANSFER",
//                     "REPEAT_AN_APPROVED_TRANSACTION",
//                     "VIEW_HISTORY_OF_EXTERNAL_TRANSFERS",
//                     "VIEW_DETAILS_OF_EXTERNAL_TRANSFER_TRANSACTIONS"
//                 ]
//             },
//             {
//                 "ID": 5,
//                 "Description": "Suyool to Suyool",
//                 "Slug": "suyooltosuyool",
//                 "IsPage": true,
//                 "Functions": [
//                     "INITIATE_A_NEW_SINGLE_SUYOOL_TO_SUYOOL_TRANSFER",
//                     "INITIATE_A_NEW_BULK_SUYOOL_TO_SUYOOL_TRANSFER",
//                     "REPEAT_SUYOOL_TO_SUYOOL_TRANSACTION",
//                     "VIEW_HISTORY_OF_SUYOOL_TO_SUYOOL_TRANSFERS",
//                     "VIEW_DETAILS_OF_SUYOOL_TO_SUYOOL_TRANSACTIONS"
//                 ]
//             },
//             {
//                 "ID": 6,
//                 "Description": "Exchange",
//                 "Slug": "exchange",
//                 "IsPage": true,
//                 "Functions": [
//                     "INITIATE_AN_EXCHANGE_TRANSACTION_USD_TO_LBP",
//                     "INITIATE_AN_EXCHANGE_TRANSACTION_LBP_TO_USD",
//                     "VIEW_HISTORY_OVERVIEW_OF_EXCHANGE_TRANSACTIONS",
//                     "VIEW_DETAILS_OF_EXCHANGE_TRANSACTIONS"
//                 ]
//             },
//             {
//                 "ID": 11,
//                 "Description": "Payroll",
//                 "Slug": "payroll",
//                 "IsPage": true,
//                 "Functions": [
//                     "UPLOAD_SUBMIT_AND_EDIT_PAYROLL",
//                     "VIEW_HISTORY_OF_PAYROLL",
//                     "APPROVE_AND_REJECT_A_PENDING_PAYROLL_2ND_SIGNATURE"
//                 ]
//             },
//             {
//                 "ID": 12,
//                 "Description": "Cash Withdrawal",
//                 "Slug": "cashout",
//                 "IsPage": true,
//                 "Functions": [
//                     "INITIATE_NEW_CASH_WITHDRAWAL_ORDER",
//                     "DOWNLOAD_CONFIRMATION_QR_CASH_OUT",
//                     "VIEW_HISTORY_OF_CASH_WITHDRAWAL_TRANSACTION"
//                 ]
//             },
//             {
//                 "ID": 13,
//                 "Description": "Cash Deposit",
//                 "Slug": "cashin",
//                 "IsPage": true,
//                 "Functions": [
//                     "INITIATE_NEW_CASH_DEPOSIT_REQUEST",
//                     "DOWNLOAD_CONFIRMATION_QR_CASH_IN",
//                     "DELETE_A_PENDING_CASH_DEPOSIT_REQUEST_FROM_OVERVIEW",
//                     "VIEW_HISTORY_OF_CASH_DEPOSIT_TRANSACTION"
//                 ]
//             },
//             {
//                 "ID": 21,
//                 "Description": "Notification",
//                 "Slug": "",
//                 "IsPage": false,
//                 "Functions": [
//                     "NOTIFICATIONS_FOR_CARDS_UPDATES",
//                     "NOTIFICATIONS_FOR_END_OF_DAY_UPDATES",
//                     "NOTIFICATIONS_FOR_CASH_WITHDRAWAL_UPDATES",
//                     "NOTIFICATIONS_FOR_CASH_DEPOSIT_UPDATES",
//                     "NOTIFICATIONS_FOR_PAYROLL_UPDATES",
//                     "NOTIFICATIONS_FOR_EXCHANGE_TRANSACTION_UPDATES",
//                     "NOTIFICATIONS_FOR_EXTERNAL_TRANSFER_UPDATES"
//                 ]
//             }
//         ]
//     },
//     {
//         "ID": 3,
//         "Description": "CORPORATE CARDS",
//         "Features": [
//             {
//                 "ID": 7,
//                 "Description": "Cards Settings",
//                 "Slug": "cardssettings",
//                 "IsPage": true,
//                 "Functions": [
//                     "REQUEST_NEW_CORPORATE_CARD_FOR_ANY_EMPLOYEE",
//                     "ACTIVATE_CARDS",
//                     "DEACTIVATE_CARDS",
//                     "SET_AND_EDIT_CARD_SETTINGS",
//                     "EDIT_CARD_LIMITS",
//                     "VIEW_CARDS_INFO_AS_LIST",
//                     "VIEW_CARDS_INFO_AS_GRID"
//                 ]
//             },
//             {
//                 "ID": 20,
//                 "Description": "Card Transactions",
//                 "Slug": "cardtransactions",
//                 "IsPage": true,
//                 "Functions": [
//                     "VIEW_HISTORY_OF_CARD_TRANSACTIONS"
//                 ]
//             }
//         ]
//     },
//     {
//         "ID": 4,
//         "Description": "SETTINGS",
//         "Features": [
//             {
//                 "ID": 8,
//                 "Description": "Legal Information",
//                 "Slug": "merchantinformation",
//                 "IsPage": true,
//                 "Functions": [
//                     "VIEW_LEGAL_ENTITY_GENERAL_INFORMATION",
//                     "EDIT_MERCHANT_PROFILE_INFORMATION",
//                     "EDIT_LOGO_AND_PROFILE_PICTURES",
//                     "SET_MERCHANT_TRANSACTIONS_LIMITS",
//                     "SWITCH_AUTO_CONVERSION",
//                     "VIEW_MERCHANT_INFORMATION"
//                 ]
//             },
//             {
//                 "ID": 10,
//                 "Description": "Employees",
//                 "Slug": "employees",
//                 "IsPage": true,
//                 "Functions": [
//                     "ADD_A_NEW_CORPORATE_EMPLOYEE",
//                     "EDIT_POSITION_ACCESS_LEVEL_OF_CORPORATE_EMPLOYEE",
//                     "BLOCK_OR_UNBLOCK_CORPORATE_EMPLOYEE",
//                     "DELETE_CORPORATE_EMPLOYEE",
//                     "VIEW_CORPORATE_EMPLOYEES",
//                     "VIEW_MERCHANT_EMPLOYEES",
//                     "CREATE_NEW_EMPLOYEE_PROFILE"
//                 ]
//             }
//         ]
//     }
// ]
export const roleAuth = (slug, identtifier) => {
  return true;
  const userAccess = sessionStorage.getItem("Features");
  const features = userAccess ? JSON.parse(userAccess) : [];

  let isAuthorized = false;

  features.forEach((category) => {
    category.Sections?.forEach((section) => {
      section.Features?.forEach((feature) => {
        if (feature.Slug === slug) {
          feature.Functions?.forEach((func) => {
            if (func === identtifier) {
              isAuthorized = true;
            }
          });
        }
      });
    });
  });

  return isAuthorized; // ✅ IMPORTANT
};

export const authFunction = (slug, identtifier, func) => {
  if (roleAuth(slug, identtifier)) {
    return func;
  } else {
    return null;
  }
};
